import React, { useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ToastService from "../../services/toastService";
import logo from "../../assets/images/logo-dark.svg";
import {
  FiAirplay,
  FiCast,
  FiSend,
  FiAtSign,
  FiBell,
  FiGrid,
  FiLogOut,
  FiUsers,
  FiPhone,
  FiLayers,
  FiChevronDown,
  FiChevronRight,
  FiSettings,
  FiFileText
} from "react-icons/fi";
import { TiMessages } from "react-icons/ti";
import { FaUniversalAccess } from "react-icons/fa";
import { IoAccessibilityOutline } from "react-icons/io5";

const Sidebar = ({ onMenuItemClicked }) => {

  const sidebarRef = useRef(null);

  const [openMenu, setOpenMenu] = React.useState(null);

  const handleMenuClick = (e) => {
    if (e.target.closest("a")) {
      onMenuItemClicked && onMenuItemClicked();
    }
  };

  const navigate = useNavigate()

  const Logout = async () => {
    try {

      const result = await Swal.fire({
        title: "Are you sure you want to logout?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Logout",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#d32f2f",
        cancelButtonColor: "#757575",
        background: "#fdfdfd",
        color: "#212121",
        iconColor: "#d32f2f",
        allowOutsideClick: false,
        allowEscapeKey: false,
        reverseButtons: true,
      });

      if (result.isConfirmed) {

        // Swal.fire({
        //   icon: "success",
        //   title: "Logged out successfully!",
        //   // showConfirmButton: true,
        //   // allowOutsideClick: false,
        //   // allowEscapeKey: false
        // });

        ToastService.success("Logged out successfully!")

        const theme = localStorage.getItem('theme')
        localStorage.clear();
        localStorage.setItem("theme", theme);

        navigate("/");

      }
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  return (
    <nav className="nxl-navigation" ref={sidebarRef}>
      <div className="navbar-wrapper">

        {/* <div className="m-header">
          <a href="/dashboard" className="b-brand">
            <img src="/images/logo/logo.svg" alt="" className="logo logo-lg" />
            <img src="/images/logo/logo-sm.svg" alt="" className="logo logo-sm" />
          </a>
        </div> */}

        <div className="m-header">
          <a href="/dashboard" className="b-brand">

            {/* Light logos */}
            <img src="/images/logo/logo.svg" alt="" className="logo logo-lg logo-light" />
            <img src="/images/logo/logo-sm.svg" alt="" className="logo logo-sm logo-light" />

            {/* Dark logos */}
            <img src={logo} alt="" className="logo logo-lg logo-dark" />
            {/* <img src="/images/logo/logo-sm.svg" alt="" className="logo logo-sm logo-dark" /> */}
          </a>
        </div>

        <div className="navbar-content">

          <ul className="nxl-navbar" onClick={handleMenuClick}>
            {/* <li class="nxl-item nxl-caption"> */}
            {/* <label>Navigation</label> */}
            {/* </li> */}
            <li className="nxl-item">
              <NavLink to="/dashboard" className="nxl-link">
                <span className="nxl-micon">
                  <FiAirplay />
                </span>
                <span className="nxl-mtext">Dashboards</span>
              </NavLink>
            </li>

            <li className="nxl-item">
              <NavLink to="/user/list" className="nxl-link">
                <span className="nxl-micon">
                  <FiUsers />
                </span>
                <span className="nxl-mtext">User Management</span>
              </NavLink>
            </li>

            <li className="nxl-item">
              <NavLink to="/roles" className="nxl-link">
                <span className="nxl-micon">
                  <IoAccessibilityOutline />

                </span>
                <span className="nxl-mtext">Roles & Permission</span>
              </NavLink>
            </li>


            <li className="nxl-item">
              <NavLink to="/callLogs" className="nxl-link">
                <span className="nxl-micon">
                  <FiPhone />

                </span>
                <span className="nxl-mtext">Call logs</span>
              </NavLink>
            </li>

            <li className="nxl-item">
              <NavLink to="/knowledgeBase" className="nxl-link">
                <span className="nxl-micon">
                  <FiFileText />

                </span>
                <span className="nxl-mtext">Knowledge Base</span>
              </NavLink>
            </li>

            {/* <li className={`nxl-item has-sub ${openMenu === "dropdown" ? "open" : ""}`}>
              <a
                className="nxl-link"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenMenu(openMenu === "dropdown" ? null : "dropdown");
                }}
              >
                <span className="nxl-micon">
                  <FiLayers />
                </span>
                <span className="nxl-mtext">Configuration</span>

                <span className="nxl-arrow">
                  {openMenu === "dropdown" ? "▾" : "▸"}
                </span>
              </a>

              <ul className="nxl-submenu">
                
                <li className="nxl-item">
                  <NavLink to="/category" className="nxl-link">
                    <span className="nxl-mtext">Category Management</span>
                  </NavLink>
                </li>

                <li className="nxl-item">
                  <NavLink to="/dropdown" className="nxl-link">
                    <span className="nxl-mtext">Dropdown Management</span>
                  </NavLink>
                </li>
              </ul>
            </li> */}


            <li className={`nxl-item has-sub ${openMenu === "dropdown" ? "open" : ""}`}>
              <a
                className="nxl-link"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenMenu(openMenu === "dropdown" ? null : "dropdown");
                }}
              >
                <span className="nxl-left">
                  <span className="nxl-micon">
                    <FiLayers size={18} />
                  </span>
                  <span className="nxl-mtext">Configuration</span>
                </span>

                <span className="nxl-arrow">
                  {openMenu === "dropdown" ? (
                    <FiChevronDown style={{ width: "18px", height: "18px" }} />
                  ) : (
                    <FiChevronRight style={{ width: "18px", height: "18px" }} />
                  )}
                </span>
              </a>

              <ul className="nxl-submenu">
                <li className="nxl-item">
                  <NavLink to="/category" className="nxl-link">
                    <span className="nxl-mtext">Category Management</span>
                  </NavLink>
                </li>

                <li className="nxl-item">
                  <NavLink to="/dropdown" className="nxl-link">
                    <span className="nxl-mtext">Dropdown Management</span>
                  </NavLink>
                </li>

                {/* <li className="nxl-item">
                  <NavLink to="/settings/SMTP" className="nxl-link">
                    <span className="nxl-mtext">Settings</span>
                  </NavLink>
                </li> */}
              </ul>
            </li>


            <li className="nxl-item">
              <NavLink to="/callStatus" className="nxl-link">
                <span className="nxl-micon">
                  <FiSettings />
                </span>
                <span className="nxl-mtext">System Mangement</span>
              </NavLink>
            </li>

            <li className="nxl-item">
              {/* <NavLink  className="nxl-link">
                <span className="nxl-micon">
                  <FiBell />
                </span>
                <span className="nxl-mtext">Notification</span>
              </NavLink> */}
            </li>

            <li className="nxl-item">
              {/* <NavLink  className="nxl-link">
                <span className="nxl-micon">
                  <FiGrid />
                </span>
                <span className="nxl-mtext">All </span>
              </NavLink> */}
            </li>

            <li className="nxl-item" onClick={() => Logout()}>
              <NavLink className="nxl-link">
                <span className="nxl-micon">
                  <FiLogOut />
                </span>
                <span className="nxl-mtext">Logout</span>
              </NavLink>
            </li>

          </ul>

        </div>
      </div>
    </nav>
  );
};

export default Sidebar;